import "../../styles/filters.css"
import {DatePicker} from "../components"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setProjectSearchFilter } from "../../redux/slices/projectsSlice"
import { getTodaysDate, getPastDateByMonth } from "../../classes/utils"
import { setQueries } from "../../redux/slices/fetchStatusSlice"
function Filters() {
    const { teams, account } = useSelector((state) => state.auth.user)
    const [ dates, setDates ] = useState({ endDate: getTodaysDate(), startDate: getPastDateByMonth(1)})
    const [ branches, setBranches ] = useState("")
    const [ tags, setTags ] = useState("")
    const [ selectedTeam, setSelectedTeam ] = useState(null)
    const [ searchProject, setSearchProject ] = useState("")
    const [ cached, setCached ] = useState(true)
    const allowTeamFilter = account.features.includes("teams")
    const dispatch = useDispatch()

    const onChange = (e, setState) =>{
        setState(e.target.value.replace(/\s/g, ""))
    }
    
    const selectTeam = (e) => {
        setSelectedTeam(e.target.value)
    }
    const onRequest = () => {
        const queries = {...dates, branches, tags, cached}
        if(selectedTeam) queries.teamUUID = selectedTeam
        dispatch(setQueries(queries))
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(setProjectSearchFilter({projectName: searchProject}))
        }, 1000)
        return () => clearTimeout(timer)
    }, [searchProject])
    return <div className="filters flex flex-col pe-4 w-full ">
        <div className="projects-filters w-full">
            <h1 className="mb-2 text-xl font-semibold text-left">Metrics criteria</h1>
            <div className="branches-tags flex flex-col">
                <input className="p-2 mb-2 w-full rounded-sm bg-input " placeholder="branches" onChange={(e) => onChange(e, setBranches)}></input>
                <input className="p-2 mb-2 w-full rounded-sm bg-input" placeholder="tags" onChange={(e) => onChange(e, setTags)}></input>
                { allowTeamFilter ? <select name="teams" id="teams-select" className="p-2 mb-2 rounded-sm bg-input cursor-pointer" placeholder="teams" onChange={selectTeam}>
                    <option value="" disabled selected hidden>teams</option>
                    { teams.map(({ uuid, name }) => {
                        return <option value={uuid} className="p-8 cursor-pointer bg-gray-200">{name}</option>
                    })}
                </select>: null
                }
            </div>
            <DatePicker setDates={setDates}></DatePicker>
            <div className="flex justify-between w-full items-center mt-2">
                <div className="flex items-center">
                    <input checked={cached} id="checked-checkbox" type="checkbox" value="false" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 cursor-pointer" onClick={() => setCached(!cached)}></input>
                    <label for="checked-checkbox" className="ml-2 text-sm font-medium">Enable cache</label>
                </div>
                <button className="align-middle py-1 px-4 text-lg rounded-sm text-sky-50 bg-button" onClick={onRequest}>Apply</button>
            </div>
        </div>
        <div className="projects-search flex flex-col mt-5 w-full border-l-2 border-double">
            <h1 className="text-lg font-semibold text-left mb-2">Filter by project</h1>
            <input className="p-2 mb-2 rounded-sm bg-input w-full" placeholder="project name" onChange={(e) => onChange(e, setSearchProject)}></input>
        </div>
    </div>
}

export default Filters